import { TypographyProps } from '@portalterreno/react-ui-core/Typography';
import Link from 'next/link';
import React from 'react';

import StyledTypography from './StyledTypography';

export type TermsAndConditionsProps = TypographyProps;

const TermsAndConditions: React.FC<TermsAndConditionsProps> = (props) => {
  return (
    <StyledTypography
      variant='small'
      weight='light'
      {...props}
    >
      Al enviar estás aceptando los{' '}
      <Link
        href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/terminos-y-condiciones`}
        target='_blank'
      >
        Términos y Condiciones
      </Link>{' '}
      de Uso.{' '}
    </StyledTypography>
  );
};

export default React.memo(TermsAndConditions);
